import { createContext, ReactNode, useContext } from "react";

import { useAnalysisSummaryData } from "@/hooks/analysisSummary/useAnalysisSummaryData";

export type IAnalysisSummaryDataContextValue = ReturnType<
  typeof useAnalysisSummaryData
>;

const AnalysisSummaryDataContext = createContext<
  IAnalysisSummaryDataContextValue | undefined
>(undefined);

export function AnalysisSummaryDataProvider({
  children
}: Readonly<{
  children: ReactNode;
}>) {
  const data = useAnalysisSummaryData();

  return (
    <AnalysisSummaryDataContext.Provider value={data}>
      {children}
    </AnalysisSummaryDataContext.Provider>
  );
}

export function useAnalysisSummaryDataContext() {
  const context = useContext(AnalysisSummaryDataContext);

  if (context === undefined) {
    throw new Error(
      "useAnalysisSummaryDataContext must be used within AnalysisSummaryDataProvider"
    );
  }

  return context;
}
